import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { Button, AlertMessage } from '../../../../components/ui'

export const LeadEditLoading: React.FC = () => {
 const navigate = useNavigate()

 return (
 <div className="space-y-6">
 <div className="flex items-center gap-4">
 <Button variant="outline" onClick={() => navigate('/leads')}>
 <ArrowLeft className="h-4 w-4 mr-2" />
 Voltar
 </Button>
 <h1 className="text-2xl font-bold text-foreground">Editar Lead</h1>
 </div>
 <AlertMessage variant="loading" message="Carregando dados do lead..." />
 </div>
 )
}

